/**
 * Saves text the console already fetched (with the operator's own bearer token — the browser can't
 * be pointed at the API URL directly, it has no way to attach that header) as a file in the visitor's
 * browser: a ``Blob`` on an object URL, given to a detached anchor with a ``download`` name, clicked
 * once and discarded. The object URL is revoked a second later, not right after the click — see why
 * below; nothing here outlives that.
 */
export function downloadText(filename: string, contentType: string, text: string): void {
  const blob = new Blob([text], { type: contentType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  // Not revoked synchronously: some browsers start the download on the NEXT tick, and an object URL
  // revoked before that tick saves a zero-byte file. A short delay costs nothing — the URL is only
  // reachable from this page's own memory, never shared.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
